import { render, staticRenderFns } from "./LLInputText.vue?vue&type=template&id=fa163cd2&scoped=true"
import script from "./LLInputText.vue?vue&type=script&lang=js"
export * from "./LLInputText.vue?vue&type=script&lang=js"
import style0 from "./LLInputText.vue?vue&type=style&index=0&id=fa163cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa163cd2",
  null
  
)

export default component.exports